import React from "react";
import styled from "styled-components";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment } from "@mui/material";
import { GrFormClose } from "react-icons/gr";

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
  margin: 10px 0px 10px 0px;
  padding: 3px;
  border: 1.5px solid #e4e4e4;
  border-radius: 4px;
  font: normal normal 600 1vw/1.1vw Open Sans;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  & .hover {
    backgroundcolor: ${({ theme }) => theme.colors.darkgrey};
  }
`;

const StyledInputBase = styled(InputBase)`
  padding: 0px 10px;
  width: 100%;
  text-align: left;
  font: ${({ main }) => {
    if (main) return "normal normal 550 13px/18px Open Sans;";
    else return "normal normal 500 13px/18px Open Sans;";
  }};
  letter-spacing: 0px;
  opacity: 1;
  align-items: center;
  & .MuiInputBase-input {
    margin-top: 0px !important;
  }
`;

const SearchIconWrapper = styled.div`
  border-left: 1.5px solid #e4e4e4;
  padding: 2.5px 4px;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function PrimarySearchBar({ value, setControl, handleSearchClick, disabled, onHandleFocus = () => {}, placeholder }) {

  const endAdornment = () => {
    if (value) {
      return (
        <InputAdornment position="end">
          <IconButton
            onClick={() => {
              setControl("");
              setTimeout(() => {
                handleSearchClick();
              }, 100)
            }}
            color="primary"
            style={{ marginRight: '-12px' }}
          >
            <GrFormClose style={{ fontSize: '18px' }} />
          </IconButton>
        </InputAdornment>
      );
    }
    return <></>;
  };

  return (
    <SearchContainer>
      <StyledInputBase
        value={value}
        disabled={disabled}
        endAdornment={endAdornment()}
        placeholder={placeholder ? placeholder : "Search"}
        inputProps={{ "aria-label": "search" }}
        onChange={e => {
          if (!e.target.value) handleSearchClick();
          setControl(e.target.value)
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            handleSearchClick(e.target.value);
          }
        }}
        onFocus={onHandleFocus}
      />
      <SearchIconWrapper >
        <SearchIcon style={{ fontSize: "20px", cursor: "pointer" }} onClick={() => handleSearchClick(value)} />
      </SearchIconWrapper>
    </SearchContainer>
  );
}
